export default class Constants {
  public static Pages = class {
    static home = '/';
    static changePassword = '/change-password';
    static changePasswordConfirm = '/change-password-confirm';
    static logOff = '/log-off';
    static loggingTest = '/logging-test';
    static accessError = '/access-error';
    static redirectLogin = '/redirect-login';
    static technicalError = '/technical-error';
    static catchAll = '*';
  };
}
